import React from 'react';
import './MessageNotificationBadge.css';

/**
 * MessageNotificationBadge - Small badge showing unread message count
 * 
 * @param {Object} props
 * @param {number} props.count - Unread message count
 */
function MessageNotificationBadge({ count }) {
    // Don't render if count is 0 or falsy
    if (!count || count <= 0) {
        return null;
    }

    // Cap display at 99+
    const displayCount = count > 99 ? '99+' : count;

    return (
        <div className="message-notification-badge" role="status" aria-live="polite">
            <span className="badge-count">{displayCount}</span>
        </div>
    );
}

export default MessageNotificationBadge;
